import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createAppPreAsyncThunk } from '../../../../common/thunk';
import ConfigService from '../../../../services/config.service';
import { Config } from './Interfaces/Config';
import { CodeInjectionType } from './Enums/CodeInjectionType';

interface CodeInjectionState {
  header?: Config;
  footer?: Config;
  body?: Config;
}

const initialState: CodeInjectionState = {};

export const getConfigs = createAppPreAsyncThunk('configs', async () => {
  return await ConfigService.getConfigs().then(response => response.data);
});

export const updateConfig = createAppPreAsyncThunk('config/update', async (config: Config) => {
  return await ConfigService.updateConfig(config).then(response => response.data);
});

const setConfig = (state: CodeInjectionState, action: PayloadAction<Array<Config>>) => {
  state.body = action.payload.find(item => item.key === CodeInjectionType.BODY);
  state.footer = action.payload.find(item => item.key === CodeInjectionType.FOOTER);
  state.header = action.payload.find(item => item.key === CodeInjectionType.HEADER);
};

export const codeInjectionSlice = createSlice({
  name: 'codeInjection',
  initialState,
  reducers: {
    setConfigHeaderValue: (state, action) => {
      if (state.header) {
        state.header.value = action.payload;
      }
    },
    setConfigBodyValue: (state, action) => {
      if (state.body) {
        state.body.value = action.payload;
      }
    },
    setConfigFooterValue: (state, action) => {
      if (state.footer) {
        state.footer.value = action.payload;
      }
    },
  },
  extraReducers: builder => {
    builder.addCase(getConfigs.fulfilled, setConfig);
    builder.addCase(updateConfig.fulfilled, () => {
      return;
    });
  },
});
export const { setConfigBodyValue, setConfigFooterValue, setConfigHeaderValue } = codeInjectionSlice.actions;

export default codeInjectionSlice.reducer;
